import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Attention } from '../interfaces/attention';
import { Invite } from '../interfaces/invite';
import { DatabaseRecord } from '../mixins/database-record';
import { ActivityLog, HasActivityLogs } from '../mixins/has-activity-logs';
import { AgencyBlocAddress, HasAgencyBlocAddresses } from './agency-bloc-address';
import { AgencyBlocCustomField } from './agency-bloc-custom-field';
import { AgencyBlocEntity } from './agency-bloc-entities';
import { AgencyBlocGroup } from './agency-bloc-group';
import { HasEmailAttribute, HasFullNameAttribute } from './search-results-record';
import { User } from './user';

export class AgencyBlocAgent extends DatabaseRecord(AgencyBlocCustomField(HasAgencyBlocAddresses(HasActivityLogs(AgencyBlocEntity(HasEmailAttribute(HasFullNameAttribute())))))) {
  public readonly $entityID = 'agentID';
  public readonly $entityType = 'Agent';
  public readonly $entityDateLabel = 'DOB';

  public agentID = 0;
  public firstName = '';
  public middleInitial = '';
  public lastName = '';
  public email2? = '';
  public birthDate = new Date();
  public npn = '';
  public ssn = '';
  public leadSource = '';
  public leadSourceOther = '';
  public classification = '';
  public type = '';
  public status = '';
  public projectCode = '';
  public homePhone = '';
  public homePhoneExt = '';
  public businessPhone = '';
  public businessPhoneExt = '';
  public cellPhone = '';
  public cellPhoneExt = '';
  public businessName = '';
  public addresses: AgencyBlocAddress[] = [];
  public group?: AgencyBlocGroup;
  public user?: User;
  public invite?: Invite;
  public attention?: Attention;
  /**
   * Get the entity date for this Model. Usually used for sorting and displaying in the UI.
   */
  public get entityDate(): Date {
    return new Date(this.birthDate);
  }

  /**
   * Get the entity ID for this Model. Usually used for sorting and displaying in the UI.
   */
  public get entityId(): number {
    return this.agentID;
  }

  constructor(data?: AgencyBlocAgent) {
    super(data);
    Object.assign(this, data);

    if (data) {
      if (this.created_at) this.created_at = new Date(this.created_at);
      if (this.updated_at) this.updated_at = new Date(this.updated_at);
      if (this.deleted_at) this.deleted_at = new Date(this.deleted_at);
      if (this.birthDate) this.birthDate = new Date(this.birthDate);
      if (this.group) this.group = new AgencyBlocGroup(this.group);
      if (this.logs) this.logs = this.logs.map((log) => new ActivityLog(log));

      this.$entityDate = this.birthDate;
      this.$entityId = this.agentID;
    }
  }

  public createFormGroup(entityType?: string): FormGroup {
    if (entityType === 'Agent') {
      return new FormGroup({
        firstName: new FormControl(this.firstName, []),
        lastName: new FormControl(this.lastName, []),
        leadDate: new FormControl(this.created_at),
        classification: new FormControl('',[]),
        thrivent_rfo:new FormControl('',[]),
        status: new FormControl(this.status, [Validators.required]),
        type: new FormControl(this.type, [Validators.required]),
        projectCode: new FormControl(this.projectCode, [Validators.required]),
      });
    }

    const group = super.createFormGroup();

    group.patchValue({
      firstName: new FormControl(this.firstName, []),
      middleInitial: new FormControl(this.middleInitial, []),
      lastName: new FormControl(this.lastName, []),
      email: new FormControl(this.email, [Validators.required, Validators.email]),
      status: new FormControl(this.status, [Validators.required]),
      type: new FormControl(this.type, [Validators.required]),
      projectCode: new FormControl(this.projectCode, [Validators.required]),
      classification: new FormControl(this.classification),
    });

    return group;
  }
}
